import { HTTP_X_ListLenders_Response_Lender } from '@api-new/mortgageservice';
import { Selector, createFeatureSelector, createSelector } from '@ngrx/store';
import { lendersAdapter } from '@shared/store/lender/lenders.reducer';
import { LendersState } from '@shared/store/lender/lenders.state';
import { SelectItem } from 'primeng/api';

const { selectAll, selectEntities } = lendersAdapter.getSelectors();
export const selectLendersState = createFeatureSelector<LendersState>('lenders');

export const selectLenders = createSelector(selectLendersState, (lendersState): HTTP_X_ListLenders_Response_Lender[] =>
  selectAll(lendersState).map((lender) => {
    return { ...lender };
  }),
);

export const selectLenderEntities = createSelector(selectLendersState, (lendersState) => selectEntities(lendersState));

export const selectIsLoadingLenders = createSelector(selectLendersState, (state): boolean => state.loading);
export const selectLenderLogoById = (lenderId: string): Selector<LendersState, string> =>
  createSelector(selectLenderEntities, (lenderEntities): string => lenderEntities[lenderId]?.logo);

export const selectIsAnyLenderExcluded = createSelector(selectLenders, (lenders) => lenders.some((lender) => lender.isExcluded));

export const selectLenderOptions = createSelector(selectLenders, (lenders): SelectItem<string>[] =>
  lenders.map((lender) => ({ label: lender.name, value: lender.id, icon: lender.logo })),
);
